export const dataTestIds = {
  USER_PROFILE_ICON: 'user-profile-icon',
  USER_SIGN_OUT_BUTTON: 'user-sign-out-button',
  USER_VIEW_PROFILE_BUTTON: 'user-view-profile-button',
  USER_PROFILE_POPOVER_MENU: 'user-profile-popover-menu',
  USER_VIEW_NEW_PROFILE_BUTTON: 'user-view-new-profile-2-button',
};
